/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import * as PaymentsActions from "../../actions/paymentsActions";
import PaymentCardForm from './PaymentCardForm';

// const RECAPTCHA_KEY = '6Lcv7LoUAAAAAG5drxQTeMQ6DRfCOFN05eKHXHip';


function PaymentCards(props) {
  const [formVisibility, setFormVisibility] = useState(false);
  const [editFormVisibility, setEditFormVisibility] = useState(false);
  const [visibleCardId, setVisibleCardId] = useState("");
  const [availableCards, setAvailableCards] = useState([]);

  const formatExpiry = (card) => {
    if (!card || !card.card) return "";
    const month = card.card.exp_month ? card.card.exp_month.toString().padStart(2, "0") : "";
    const year = card.card.exp_year ? card.card.exp_year.toString().slice(-2) : "";
    return `Expires ${month}/${year}`;
  };

  const getBrandIcon = (brand = "") => {
    const normalizedBrand = brand.toLowerCase();
    const brandIconMap = {
      visa: "fa-cc-visa",
      mastercard: "fa-cc-mastercard",
      amex: "fa-cc-amex",
      'american express': "fa-cc-amex",
      discover: "fa-cc-discover",
      diners: "fa-cc-diners-club",
      jcb: "fa-cc-jcb"
    };

    return brandIconMap[normalizedBrand] || "fa-credit-card";
  };

  const loadPaymentMethods = () => {
    props.dispatch(
      PaymentsActions.getAllUserPaymentMethods((response) => {
        if (response.status) {
          setAvailableCards(response.data.data);
        }
      })
    );
  };

  useEffect(() => {
    loadPaymentMethods();
  }, []);


  const deletePaymentCard = (cardId) => {
    const {onDeleteCard} = props;
    props.dispatch(PaymentsActions.deleteCard(cardId, response => {
      if (response.status) {
        loadPaymentMethods();
        onDeleteCard && onDeleteCard();
      } else {
        alert('Failed to delete the selected Payment Method');
      }
    }));
  };

  const { viewMode, onSelectCard, selectedCard } = props;

  return (
    <div className="payment-cards-container">
      <div className="payment-methods-header">
        <div>
          <h2>Payment Methods</h2>
          <p>Manage your saved cards</p>
        </div>
      </div>

      <div className="payment-method-list">
        {availableCards && availableCards.length > 0 ? (
          availableCards.map((card, idx) => (
            <div className="payment-card" key={`card_${idx}_row`}>
              <div className="payment-card-info">
                <div className="payment-card-icon">
                  <i className={`fa ${getBrandIcon(card.card.brand)}`} />
                </div>
                <div className="payment-card-text">
                  <div className="card-title">{`${card.card.brand || "Card"} •••• ${card.card.last4}`}</div>
                  <div className="card-subtitle">{formatExpiry(card)}</div>
                </div>
              </div>

              <div className="payment-card-actions">
                {viewMode && viewMode === "select" ? (
                  <i
                    className={`fa fa${selectedCard && card.id === selectedCard.id ? "-dot" : ""}-circle-o`}
                    onClick={() => (onSelectCard ? onSelectCard(card) : null)}
                  />
                ) : null}

                {viewMode && viewMode === "edit" ? (
                  <React.Fragment>
                    <button
                      className="icon-button"
                      onClick={() => {
                        setEditFormVisibility(true);
                        setVisibleCardId(card.id);
                      }}
                      aria-label="View payment method"
                    >
                      <i className="fa fa-eye" />
                    </button>
                    <button
                      className="icon-button danger"
                      onClick={() => deletePaymentCard(card.id)}
                      aria-label="Delete payment method"
                    >
                      <i className="fa fa-trash-o" />
                    </button>
                  </React.Fragment>
                ) : null}
              </div>

              {editFormVisibility && visibleCardId === card.id ? (
                <div className="payment-form">
                  <div className="row title-row info-row">
                    <div className="col-sm-10">View Payment Method</div>
                    <div className="col-sm-2 button-container">
                      <i
                        className="fa fa-close"
                        onClick={() => setEditFormVisibility(false)}
                      />
                    </div>
                  </div>
                  <div className="row form">
                    <div className="col-md-12">
                      <input
                        disabled
                        placeholder="Name on Card"
                        value={card.billing_details.name}
                      />
                    </div>
                    <div className="col-md-12">
                      <input
                        placeholder="Card Number"
                        value={`xxxx-xxxx-xxxx-${card.card.last4}`}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        disabled
                        placeholder="Expiry Month"
                        value={card.card.exp_month}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        disabled
                        placeholder="Expiry Year"
                        value={card.card.exp_year}
                      />
                    </div>
                    <div className="col-md-12">
                      <input
                        disabled
                        placeholder="Billing Address"
                        value={card.billing_details.address.line1}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing City"
                        value={card.billing_details.address.city}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing State"
                        value={card.billing_details.address.state}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing Zip"
                        value={card.billing_details.address.postal_code}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ))
        ) : (
          <div className="info-row">
            <span className="text-italic">No Payment Method Added</span>
          </div>
        )}
      </div>

      {viewMode && viewMode === "edit" ? (
        formVisibility ? (
          <div className="payment-form">
            <div className="row title-row info-row">
              <div className="col-sm-10">Add New Payment Method</div>
              <div className="col-sm-2 button-container">
                <i
                  className="fa fa-close"
                  onClick={() => setFormVisibility(false)}
                />
              </div>
            </div>
            <PaymentCardForm
              onAddCardRequest={() => {
                loadPaymentMethods();
                setFormVisibility(false);
                props.onAddCardRequest && props.onAddCardRequest();
              }}
              dispatch={props.dispatch}
            />
          </div>
        ) : (
          <button className="add-payment-method" onClick={() => setFormVisibility(true)}>
            <i className="fa fa-plus-circle" />
            Add New Payment Method
          </button>
        )
      ) : null}
    </div>
  );
}

export default PaymentCards;



// WEBPACK FOOTER //
// ./src/components/checkout/PaymentCards.js